import React from 'react';
import { TextInput } from 'is24-corecss';
import { useTranslation } from 'react-i18next';

const IbanInput: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='grid grid-flex'>
      <div className='grid-item one-whole font-heading-xsmall-bold margin-bottom-m margin-top-m'>
        {t('IbanInput.heading')}
      </div>
      <div className='grid-item one-whole'>
        <TextInput id='iban' label={t('IbanInput.label')} placeholder='' required={true} mandatory={true} />
      </div>
    </div>
  );
};

export default IbanInput;
